import { FC } from 'react';
import { stringToRichText } from '@belong/contentful/helpers';
import { SectionWrapper } from '@belong/ui-components/components/styles/Section/Section.styles';
import { IntroductionText } from '@belong/ui-components/index';
import fallbacks from './content/fallbacks.json';

interface INoSearchResultsFallbackProps {
  query: string;
}

const { EMPTY_SEARCH, NO_RESULTS } = fallbacks;

const IntroText = ({ heading, body }) => (
  <IntroductionText headingLevel="h2" heading={heading} body={stringToRichText(body).html} />
);
// Fallback component when no search query is provided
export const EmptyQueryFallback: FC = () => {
  return (
    <SectionWrapper hasPaddingBottom hasPaddingTop>
      <IntroText heading={EMPTY_SEARCH.HEADING} body={EMPTY_SEARCH.BODY} />
    </SectionWrapper>
  );
};

// Fallback component when no results are found for a specific query
export const NoResultsFallback: FC<INoSearchResultsFallbackProps> = ({ query }) => {
  const heading = `${NO_RESULTS.HEADING} \u201C${query}\u201D`;
  return (
    <SectionWrapper hasPaddingBottom hasPaddingTop>
      <IntroText heading={heading} body={NO_RESULTS.BODY} />
    </SectionWrapper>
  );
};
